import type { AiAppCenterModule } from '../types'

export const promotionModule: AiAppCenterModule = {
  key: 'promotion',
  label: '营销中心',
  desc: '活动市场：分类 / 节日 / 行业 / 场景模板货架',
  path: '/promotion',
  homePath: '/promotion/activity/activity-market',
  standalonePath: '/ai-Application-center/promotion/activity/activity-market',
  icon: 'ep:present',
  color: '#db2777'
}